import { Button } from '@heroui/react';
import { ArrowDown, ArrowUp, Copy, Trash2 } from 'lucide-react';
import React, { FC } from 'react';

import { BLOCK_LABELS } from '../model/factories';
import type { EmailBlock } from '../model/types';

/** Skrót treści bloku, żeby lista czytała się bez wchodzenia w każdy element. */
const summary = (block: EmailBlock): string => {
  switch (block.kind) {
    case 'heading': return block.text;
    case 'text': return block.text.replace(/\n+/g, ' ');
    case 'button': return block.label;
    case 'image': return block.alt || block.src || 'brak grafiki';
    case 'list': return block.items.filter(Boolean).join(', ');
    case 'spacer': return `${block.height} px`;
    case 'footer': return block.text;
    default: return '';
  }
};

interface BlockListProps {
  blocks: EmailBlock[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onMove: (id: string, move: 'up' | 'down') => void;
  onDuplicate: (id: string) => void;
  onRemove: (id: string) => void;
}

export const BlockList: FC<BlockListProps> = ({
  blocks, selectedId, onSelect, onMove, onDuplicate, onRemove,
}) => (
  <div className="flex flex-col gap-2">
    <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Bloki wiadomości</p>
    <div className="flex flex-col gap-1">
      {blocks.map((block, index) => {
        const isActive = block.id === selectedId;
        return (
          <div
            key={block.id}
            className={`rounded-lg border px-3 py-2 transition-colors ${isActive
              ? 'border-gray-900 bg-gray-50'
              : 'border-gray-200 bg-white hover:border-gray-300'}`}
          >
            <button
              type="button"
              className="w-full text-left"
              onClick={() => onSelect(block.id)}
            >
              <span className="block text-xs font-semibold text-gray-900">{BLOCK_LABELS[block.kind]}</span>
              <span className="block truncate text-xs text-gray-500">{summary(block)}</span>
            </button>

            {isActive && (
              <div className="mt-2 flex items-center gap-1">
                <Button
                  isIconOnly
                  size="sm"
                  variant="light"
                  aria-label="Wyżej"
                  isDisabled={index === 0}
                  onPress={() => onMove(block.id, 'up')}
                >
                  <ArrowUp className="h-4 w-4" />
                </Button>
                <Button
                  isIconOnly
                  size="sm"
                  variant="light"
                  aria-label="Niżej"
                  isDisabled={index === blocks.length - 1}
                  onPress={() => onMove(block.id, 'down')}
                >
                  <ArrowDown className="h-4 w-4" />
                </Button>
                <Button
                  isIconOnly
                  size="sm"
                  variant="light"
                  aria-label="Powiel"
                  onPress={() => onDuplicate(block.id)}
                >
                  <Copy className="h-4 w-4" />
                </Button>
                <Button
                  isIconOnly
                  size="sm"
                  variant="light"
                  color="danger"
                  aria-label="Usuń"
                  onPress={() => onRemove(block.id)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
